export default __webpack_public_path__ + "svg/calendar/2025/8/noviembre.svg?ca33b434";